import { ChangeDetectionStrategy, Component, ElementRef, ViewChild } from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { TranslateService } from '@ngx-translate/core';
import type { MenuItem } from "primeng/api";
import * as FlatModels from "@medsurf/flat-models";
import * as FlatFacades from "@medsurf/flat-facades";

@Component({
    selector: 'medsurf-slide-edit-keymap',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './keymap.component.html',
    styleUrls: ['./keymap.component.scss'],
    standalone: false
})
export class KeymapComponent {
  @ViewChild('edit_overlay_template_scroll_panel', {static: false}) editPanelScrollPanel: ElementRef<HTMLDivElement>;
	
	getKeymapColumnMenuItems = (data: FlatModels.ActionMenusAuthorModels.MenuItemsAction) => {
    if (data.type !== 'keymapColumn') return
    const {keymap} = data;
		return [
			{
				label: this.translate.instant('global.keymap_column_add'),
				icon: FlatModels.ButtonDesignModels.ButtonDefaultIcons.ADD,
				command: () => this.#addKeymapColumn(keymap)
			}
		] satisfies MenuItem[];
	}
  annotation: FlatModels.AnnotationEntityModels.Keymap;
  readonly FlatModels = FlatModels;
  
  constructor(private alertControlFacade: FlatFacades.AlertControlFacade,
              public slideAuthorFacade: FlatFacades.SlideAuthorFacade,
              public translate: TranslateService) {
    // Update Annotation
    this.slideAuthorFacade.currentSelectedSlideAnnotation$.pipe(takeUntilDestroyed()).subscribe((annotation) => {
      if (this.annotation?.id !== annotation?.id && this.editPanelScrollPanel) {
        this.editPanelScrollPanel.nativeElement.scrollTop = 0;
      }
      this.annotation = structuredClone(annotation) as FlatModels.AnnotationEntityModels.Keymap;
    });
  }
  
  #addKeymapColumn(keymap: FlatModels.AnnotationEntityModels.Keymap) {
	  const keymapClone = structuredClone(keymap);
	  this.slideAuthorFacade.requestAddKeymapColumn(keymapClone, 'history.keymap_add_column').subscribe({
		  error: (result) => this.alertControlFacade.requestAddError(result),
	  });
  }
}
